import PropTypes from 'prop-types'
import React from 'react'

import {
    TIME_SINCE_TIMESTAMP_SECONDS,
    TIME_SINCE_TIMESTAMP_MINUTES,
    TIME_SINCE_TIMESTAMP_HOURS,
    TIME_SINCE_TIMESTAMP_DAYS,
    TIME_SINCE_TIMESTAMP_MONTHS,
    TIME_SINCE_TIMESTAMP_YEARS,
} from './translations'

import { helpers } from 'react-wot-bootstrap'

const defaultLocalizations = {
    seconds: TIME_SINCE_TIMESTAMP_SECONDS,
    minutes: TIME_SINCE_TIMESTAMP_MINUTES,
    hours: TIME_SINCE_TIMESTAMP_HOURS,
    days: TIME_SINCE_TIMESTAMP_DAYS,
    months: TIME_SINCE_TIMESTAMP_MONTHS,
    years: TIME_SINCE_TIMESTAMP_YEARS,
}

const propTypes = {
    timestamp: PropTypes.number,
    localizations: PropTypes.shape({
        seconds: PropTypes.func,
        minutes: PropTypes.func,
        hours: PropTypes.func,
        days: PropTypes.func,
        months: PropTypes.func,
        years: PropTypes.func,
    }),
}

const defaultProps = {
    localizations: defaultLocalizations,
}

class FormattedTimeSince extends React.PureComponent {
    render() {
        if (!this.props.timestamp) {
            return (<span>{helpers.DEFAULT_ERROR}</span>)
        }
        return helpers.getTimeSinceTimestamp(this.props.timestamp, this.props.localizations)
    }
}

FormattedTimeSince.propTypes = propTypes
FormattedTimeSince.defaultProps = defaultProps

export default FormattedTimeSince



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/FormattedTimeSince/FormattedTimeSince.js